import { useState } from "react";
import { Box, Collapse, Flex, Text, Tooltip, Icon } from "@chakra-ui/react";
import { ListFilter } from "lucide-react";
import { ROTULO_SECAO, COR_ROTULO, SOMBRA } from "../VendaCardV2/ui";
import { FaBackspace, FaCheckCircle, FaExclamationTriangle, FaClock, FaTruck, FaFileInvoice, FaBoxOpen, FaBolt, FaHandshake, FaTag, FaChevronDown, FaChevronUp, FaFilter, FaShippingFast, FaTimesCircle, FaUndo } from "react-icons/fa";

const mainGroups = [
    {
        label: "Status",
        filters: [
            { key: "taga_confirmadas", label: "Confirmadas", color: "green.400", textColor: "white", onClickValue: 1, icon: FaCheckCircle },
            { key: "taga_pendentes", label: "Pendentes", color: "yellow.300", textColor: "black", onClickValue: 3, icon: FaClock },
            { key: "taga_canceladas", label: "Canceladas", color: "red.400", textColor: "white", onClickValue: 2, icon: FaExclamationTriangle },
        ],
    },
    {
        label: "Envio",
        filters: [
            { key: "total_vendas_enviar_hoje", label: "Enviar Hoje", color: "blue.500", textColor: "white", onClickValue: 11, icon: FaTruck },
            { key: "total_vendas_atrasadas", label: "Atrasadas", color: "orange.500", textColor: "white", onClickValue: 12, icon: FaExclamationTriangle },
            { key: "total_vendas_problemas", label: "Problemas", color: "gray.700", textColor: "white", onClickValue: 10, icon: FaExclamationTriangle },
        ],
    },
    {
        label: "Itens",
        filters: [
            { key: "item_cancelado", label: "Item cancelado", color: "red.500", textColor: "white", onClickValue: 60, icon: FaTimesCircle },
            { key: "devolucao_parcial", label: "Devolução parcial", color: "purple.500", textColor: "white", onClickValue: 61, icon: FaUndo },
        ],
    },
];

const extraGroups = [
    {
        label: "Conferencia",
        filters: [
            { key: "conf_pendente", label: "Pendente", color: "gray.400", textColor: "white", onClickValue: 20, icon: FaClock },
            { key: "conf_sucesso", label: "Conferida", color: "green.500", textColor: "white", onClickValue: 21, icon: FaCheckCircle },
            { key: "conf_problema", label: "Problema", color: "red.500", textColor: "white", onClickValue: 22, icon: FaExclamationTriangle },
        ],
    },
    {
        label: "NF-e / Etiqueta",
        filters: [
            { key: "nfe_emitida", label: "NFe Emitida", color: "teal.500", textColor: "white", onClickValue: 30, icon: FaFileInvoice },
            { key: "nfe_pendente", label: "NFe Pendente", color: "pink.400", textColor: "white", onClickValue: 31, icon: FaFileInvoice },
            { key: "etiq_gerada", label: "Etiq. Gerada", color: "blue.600", textColor: "white", onClickValue: 32, icon: FaTag },
            { key: "etiq_pendente", label: "Etiq. Pendente", color: "gray.500", textColor: "white", onClickValue: 33, icon: FaTag },
        ],
    },
    {
        label: "Outros",
        filters: [
            { key: "estoque_taga", label: "Estoque TAGA", color: "purple.500", textColor: "white", onClickValue: 40, icon: FaBoxOpen },
            { key: "flex_ml", label: "Flex ML", color: "cyan.600", textColor: "white", onClickValue: 50, icon: FaBolt },
            { key: "entrega_combinar", label: "A Combinar", color: "orange.700", textColor: "white", onClickValue: 51, icon: FaHandshake },
            { key: "melhor_envio", label: "Melhor Envio", color: "blue.400", textColor: "white", onClickValue: 52, icon: FaShippingFast },
        ],
    },
];

const extraFilterValues = extraGroups.flatMap(g => g.filters.map(f => f.onClickValue));

export default function StatusVendasTaga({
    totalVendasTAGA,
    filtrosStatusTaga,
    toggleFiltroStatusTaga,
    limparFiltrosStatusTaga,
    v2,
}) {
    const [expanded, setExpanded] = useState(false);
    const extraAtivos = filtrosStatusTaga.filter(f => extraFilterValues.includes(f)).length;

    return (
        <Box w="100%" mx="auto" mt={2} px={{ base: v2 ? 3 : 2, md: 4 }} pt={3} pb={1} borderRadius={v2 ? "xl" : "lg"} boxShadow={v2 ? SOMBRA : "md"} bg={v2 ? "white" : "gray.50"}
            border="1px solid" borderColor={v2 ? "gray.200" : "#FF9F59"}>
            {/* Header */}
            <Flex align="center" justify="space-between" mt={v2 ? 0 : -5} mb={v2 ? 2.5 : 1.5} px={v2 ? 0 : 1} minH={v2 ? "20px" : undefined}>
                {v2 ? (
                    <Flex align="center" gap={1.5} color={COR_ROTULO}>
                        <Icon as={ListFilter} boxSize="13px" strokeWidth={2.25} />
                        <Text {...ROTULO_SECAO}>Filtros rápidos</Text>
                    </Flex>
                ) : (
                <Text
                    fontSize="8px"
                    color="#F68633"
                    fontWeight="bold"
                    bg="white"
                    w="80px"
                    px={1}
                    borderRadius="md"
                    border="1px solid #FF9F59"
                    textAlign="center"
                    lineHeight="14px"
                >
                    FILTROS RAPIDOS
                </Text>
                )}
                {filtrosStatusTaga.length > 0 && (
                    <Tooltip label="Limpar todos os filtros" hasArrow>
                        <Box as="button" onClick={limparFiltrosStatusTaga} bg="gray.600" color="white" borderRadius="md" px={2} py={0.5} fontSize="9px" fontWeight="bold" _hover={{ bg: "gray.800" }} transition="all 0.15s" display="flex" alignItems="center" gap={1}>
                            <FaBackspace size={10} />
                            <Text>{filtrosStatusTaga.length} ativo{filtrosStatusTaga.length > 1 ? 's' : ''}</Text>
                        </Box>
                    </Tooltip>
                )}
            </Flex>

            {/* Grupos principais */}
            <Flex wrap="wrap" gap={{ base: 1.5, md: 2 }} justify="center" pb={2} px={{ base: 0, md: 2 }}>
                {mainGroups.map((group, gi) => (
                    <Flex key={group.label} align="center" gap={{ base: 1.5, md: 2 }} flexShrink={0}>
                        {gi > 0 && <Box h="30px" w="1px" bg="gray.300" flexShrink={0} display={{ base: "none", sm: "block" }} />}
                        {group.filters.map(filter => (
                            <FilterChip
                                key={filter.key}
                                filter={filter}
                                count={totalVendasTAGA[filter.key]}
                                isActive={filtrosStatusTaga.includes(filter.onClickValue)}
                                onClick={() => toggleFiltroStatusTaga(filter.onClickValue)}
                            />
                        ))}
                    </Flex>
                ))}
            </Flex>

            {/* Botão expandir */}
            <Flex justify="center" pb={2}>
                <Box
                    as="button"
                    onClick={() => setExpanded(!expanded)}
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    px={3}
                    py={0.5}
                    borderRadius="full"
                    bg={expanded ? "gray.200" : "white"}
                    border="1px solid"
                    borderColor="gray.300"
                    color="gray.500"
                    fontSize="10px"
                    fontWeight="600"
                    _hover={{ bg: "gray.100", borderColor: "gray.400" }}
                    transition="all 0.15s"
                >
                    <Icon as={FaFilter} boxSize="9px" />
                    <Text>Mais filtros</Text>
                    {extraAtivos > 0 && (
                        <Box bg="orange.400" color="white" borderRadius="full" px={1.5} fontSize="9px" fontWeight="800" lineHeight="16px">
                            {extraAtivos}
                        </Box>
                    )}
                    <Icon as={expanded ? FaChevronUp : FaChevronDown} boxSize="8px" />
                </Box>
            </Flex>

            {/* Grupos extras */}
            <Collapse in={expanded} animateOpacity>
                <Box borderTop="1px dashed" borderColor="gray.200" pt={2.5} pb={2}>
                    <Flex wrap="wrap" gap={{ base: 1.5, md: 2 }} justify="center" px={{ base: 0, md: 2 }}>
                        {extraGroups.map((group, gi) => (
                            <Flex key={group.label} align="center" gap={{ base: 1.5, md: 2 }} flexWrap="wrap" justify="center">
                                {gi > 0 && <Box h="30px" w="1px" bg="gray.300" flexShrink={0} display={{ base: "none", md: "block" }} />}
                                <Text fontSize="9px" fontWeight="700" color="gray.400" textTransform="uppercase" whiteSpace="nowrap" letterSpacing="0.3px" w={{ base: "100%", md: "auto" }} textAlign="center">
                                    {group.label}
                                </Text>
                                {group.filters.map(filter => (
                                    <FilterChip
                                        key={filter.key}
                                        filter={filter}
                                        count={totalVendasTAGA[filter.key]}
                                        isActive={filtrosStatusTaga.includes(filter.onClickValue)}
                                        onClick={() => toggleFiltroStatusTaga(filter.onClickValue)}
                                    />
                                ))}
                            </Flex>
                        ))}
                    </Flex>
                </Box>
            </Collapse>
        </Box>
    );
}

function FilterChip({ filter, count, isActive, onClick }) {
    return (
        <Box
            as="button"
            onClick={onClick}
            cursor="pointer"
            bg={isActive ? filter.color : "white"}
            color={isActive ? filter.textColor : "gray.600"}
            border="1.5px solid"
            borderColor={isActive ? filter.color : "gray.200"}
            borderRadius="full"
            px={{ base: 2.5, md: 3.5 }}
            py={{ base: 1, md: 1.5 }}
            transition="all 0.15s"
            whiteSpace="nowrap"
            flexShrink={0}
            boxShadow={isActive ? "md" : "none"}
            _hover={{
                borderColor: filter.color,
                bg: isActive ? filter.color : "gray.50",
                color: isActive ? filter.textColor : filter.color,
                boxShadow: "sm",
            }}
        >
            <Flex align="center" gap={1}>
                <Icon as={filter.icon} boxSize={{ base: "10px", md: "12px" }} />
                {count !== undefined && count !== null && (
                    <Text fontSize={{ base: "11px", md: "13px" }} fontWeight="800">{count}</Text>
                )}
                <Text fontSize={{ base: "10px", md: "12px" }} fontWeight="600">{filter.label}</Text>
            </Flex>
        </Box>
    );
}
